const paymentCallbackKeys = ['cardno', 'paymenttype', 'currency', 'date', 'time', 'txnfee', 'amount', 'orderid', 'hash', 'txnid'];
export default paymentCallbackKeys;
